module.exports = __webpack_public_path__ + "img/tabicon_8.8622d80b.png";